import React, { useState, useEffect } from "react";
import { getAllMPSteelElevatedTempTables } from '../../services/tables/MPSteelElevatedTempTableService';
import MPSteelElevatedTempTable from "../../components/tecnical-sheets/MPSteelElevatedTempTable";
import { Container, Backdrop, CircularProgress } from "@mui/material";
import Notify from "../../components/global/Notify";

export default function MPSteelElevatedTempTablePage() {
  const [searchString, setSearchString] = useState('');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await getAllMPSteelElevatedTempTables(0, 20, searchString);
        setRows(res.content);
      } catch (error) {
        if (error?.silent) return;

        notify(error.message || "Erro desconhecido", false);
      } finally {
        setLoading(false);
      }
    })();
  }, [searchString]);

  const notify = (message, isSuccessMessage) => {
    if (isSuccessMessage) {
      Notify.success(message);
    } else {
      Notify.error(message);
    }
  };

  const onSearchChange = (search) => setSearchString(search);

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        width: "100%",
        maxWidth: "100vw",
        px: 2,
        py: 2,
        position: "relative",
        boxShadow: 4,
      }}
    >
      <MPSteelElevatedTempTable
        rows={rows}
        onSearchChange={onSearchChange}
      />

      <Backdrop
        open={loading}
        sx={{
          position: "absolute",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          color: "#04642c",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <CircularProgress color="inherit" size={40} />
      </Backdrop>
    </Container>
  );
}
